import React, { useState } from 'react';
import { t } from '../../../i18n';
import {Mutation, Query} from "react-apollo";
import queries from "../../../queries";
import ImageUploader from '../../uploaders/ImageUploader';
import FieldEditor from './FieldEditor';
import fieldCreationDialog from '../../dialogs/FieldCreationDialog';

export default function CardsGameEditor({ cell, language, screenType }) {

    const [cardImagesCell, setCardsGameCell] = useState(cell);

    return(
        <Query query={queries.cells.cards_game.get} variables={{ id: cell.id }}>
                {
                    ({loading, error, data}) => {
                    console.log("data", data);
                    if (loading) return t('ui.common.loading');
                    if (error) return `Error!: ${error}`;
                    const { cardsGameCell } = data;

                    return(
                        <Mutation mutation={queries.cells.cards_game.update} variables={{ id: cell.id }}>
                            {
                                (updateCardsGameCell, { loading, error }) => {
                                    if (loading) return "Saving...";
                                    if (error) return `Error!: ${error}`;

                                    console.log("cardsGameCell", cardsGameCell);

                                    return (
                                        <div>
                                            <h2>Edit Cards Game Cell</h2>
                                            <form onSubmit={(e) => {
                                                e.preventDefault();
                                                updateCardsGameCell({ variables: {input: { id: cell.id, card_1_uri: cardImagesCell.card_1_uri, card_2_uri: cardImagesCell.card_2_uri, card_3_uri: cardImagesCell.card_3_uri, card_4_uri: cardImagesCell.card_4_uri, card_5_uri: cardImagesCell.card_5_uri, card_6_uri: cardImagesCell.card_6_uri, card_7_uri: cardImagesCell.card_7_uri, card_8_uri: cardImagesCell.card_8_uri, verso_uri: cardImagesCell.verso_uri, timer: parseInt(cardImagesCell.timer), timer_color_1: cardImagesCell.timer_color_1, timer_color_2: cardImagesCell.timer_color_2, timer_color_3: cardImagesCell.timer_color_3, btn_start_color: cardImagesCell.btn_start_color, btn_start_text_color: cardImagesCell.btn_start_text_color } } });
                                            }}>
                                                {[1,2,3,4,5,6,7,8].map((i) => {
                                                    return (
                                                        <ImageUploader onUpload={(e)=>{
                                                            setCardsGameCell({
                                                                ...cardsGameCell,
                                                                [`card_${i}_uri`]: e
                                                            });
                                                        }} value={cardsGameCell[`card_${i}_uri`] || cell[`card_${i}_uri`]}/>
                                                    );
                                                })}
                                                <br/>
                                                <ImageUploader onUpload={(e)=>{
                                                    setCardsGameCell({
                                                        ...cardsGameCell,
                                                        verso_uri: e
                                                    });
                                                }} value={cardsGameCell.verso_uri}/>
                                                <br/>
                                                timer:
                                                <input type="number" value={cardsGameCell.timer} onChange={(e) => {
                                                    setCardsGameCell({
                                                        ...cardsGameCell,
                                                        timer: e.target.value
                                                    });
                                                }}/>
                                                <br/>
                                                <br/>
                                                <h3>Couleurs du minuteur</h3>
                                                <div style={{display: 'flex', gap: '1em', alignItems: 'center'}}>
                                                    <label style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                                        Début
                                                        <input
                                                            type="color"
                                                            value={cardImagesCell.timer_color_1 || cardsGameCell.timer_color_1 || '#2B5A2F'}
                                                            onChange={(e) => {
                                                                setCardsGameCell({
                                                                    ...cardsGameCell,
                                                                    timer_color_1: e.target.value
                                                                });
                                                            }}
                                                        />
                                                    </label>
                                                    <label style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                                        Milieu
                                                        <input
                                                            type="color"
                                                            value={cardImagesCell.timer_color_2 || cardsGameCell.timer_color_2 || '#FEC700'}
                                                            onChange={(e) => {
                                                                setCardsGameCell({
                                                                    ...cardsGameCell,
                                                                    timer_color_2: e.target.value
                                                                });
                                                            }}
                                                        />
                                                    </label>
                                                    <label style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                                        Fin
                                                        <input
                                                            type="color"
                                                            value={cardImagesCell.timer_color_3 || cardsGameCell.timer_color_3 || '#EF645B'}
                                                            onChange={(e) => {
                                                                setCardsGameCell({
                                                                    ...cardsGameCell,
                                                                    timer_color_3: e.target.value
                                                                });
                                                            }}
                                                        />
                                                    </label>
                                                </div>
                                                <br/>
                                                <h3>Couleurs du bouton de démarrage</h3>
                                                <div style={{display: 'flex', gap: '1em', alignItems: 'center'}}>
                                                    <label style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                                        Fond
                                                        <input
                                                            type="color"
                                                            value={cardImagesCell.btn_start_color || cardsGameCell.btn_start_color || '#2B5A2F'}
                                                            onChange={(e) => {
                                                                setCardsGameCell({
                                                                    ...cardsGameCell,
                                                                    btn_start_color: e.target.value
                                                                });
                                                            }}
                                                        />
                                                    </label>
                                                    <label style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                                        Texte
                                                        <input
                                                            type="color"
                                                            value={cardImagesCell.btn_start_text_color || cardsGameCell.btn_start_text_color || '#FFFFFF'}
                                                            onChange={(e) => {
                                                                setCardsGameCell({
                                                                    ...cardsGameCell,
                                                                    btn_start_text_color: e.target.value
                                                                });
                                                            }}
                                                        />
                                                    </label>
                                                </div>
                                                <br/>
                                                <h3>Champs</h3>
                                                {cardsGameCell.fields.map((field) => {
                                                    return (
                                                        <FieldEditor
                                                            key={field.id}
                                                            field={field}
                                                            cell={cell}
                                                            language={language}
                                                            screenType={screenType}
                                                        />
                                                    );
                                                })}

                                                <Mutation
                                                    mutation={queries.form_fields.create}
                                                    refetchQueries={() => [{ query: queries.cells.cards_game.get, variables: { id: cell.id } }]}
                                                    >
                                                    {(createFormField, { loading, error }) => {
                                                        if (loading) return "Creating field...";
                                                        if (error) return `Error!: ${error.message}`;
                                                        return (
                                                        <button
                                                            type="button"
                                                            onClick={async () => {
                                                            const newField = await fieldCreationDialog({ cell_id: cell.id });
                                                            await createFormField({ variables: { input: newField } });
                                                            }}
                                                        >
                                                            Nouveau champ
                                                        </button>
                                                        );
                                                    }}
                                                </Mutation>
                                                <br/>
                                                <button type="submit">Save</button>
                                            </form>
                                            <br/>
                                            <br/>
                                        </div>
                                    );
                                }
                            }
                        </Mutation>
                    )
                }
            }
        </Query>
    )
}